import LazyLoad from 'components/LazyLoad/LazyLoad';

export default LazyLoad;
